export default __webpack_public_path__ + "static/media/02-coins.2ded3a14.jpg";